<template>
  <div class="add-page" :style="{minWidth: '1100px', overflowX: 'hidden', 'height': disabled ? 'calc(100vh - 236px)' : 'calc(100vh - 300px)' }">
    <div class="relative">
      <div style="text-align: right;margin-bottom:20px" v-if="disabled">
        <el-button size="medium" v-if="$route.query.auditStatus !== 4" type="primary" @click="handlerOpration" style="">审核</el-button>
        <el-button size="medium" v-if="$route.query.auditStatus !== 4" type="primary" @click="disab(false)" style="">编辑</el-button>
        <!-- <el-button size="medium" type="primary" v-if="!disabled" @click="disab(true)" style="">取消</el-button>
        <el-button :disabled="disabled" size="medium" v-if="!disabled" type="primary" @click="save({applyType:1})" style="">确定</el-button> -->
      </div>
      <member-edit ref="memberEdit" :disabled="disabled" :applyId="$route.query.applyId"/>
    </div>
    <div class="text-right add-bottom fixed" v-if="!disabled">
      <!-- <el-button size="medium" type="primary" @click="disab(true)" style="">取消</el-button> -->
      <el-button size="medium" type="primary" @click="disab(true)" style="">取消</el-button>
      <el-button size="medium" type="primary" @click="handlerOpration" style="">审核</el-button>
      <el-button size="medium" type="primary" @click="save({applyType:1})" style="">保存</el-button>
      <!-- <el-button size="medium" type="primary" @click="save({applyType:1})" style="">提交申请</el-button> -->
    </div>
    <el-dialog
      title="会员申请审核"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div>
        <div>
          <el-form :model="dialogForm" ref="dialogForm" label-width="120px" :hide-required-asterisk="true">
            <div @keyup.enter.stop="handleAudit">
              <el-form-item label="审核情况" prop="auditStatus" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                <el-select v-model="dialogForm.auditStatus" placeholder="审核情况" filterable style="width: 100%;">
                  <el-option v-for="(item, key) in $enums.vipAuditStatus2" :key="key" :label="item" :value="Number(key)"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="text-right">
          <el-button size="medium" @click="handleClose">取消</el-button>
          <el-button size="medium" type="primary" @click="handleAudit" style="margin-right: 0px;">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MemberEdit from './components/Member-Edit'
export default {
  name: 'apply',
  components: { MemberEdit },
  props: [],
  data () {
    return {
      disabled: true,
      dialogVisible: false,
      dialogForm: {}
    }
  },
  methods: {
    save () {
      this.$refs.memberEdit.commit({ applyType: 1 })
    },
    async disab (type) {
      this.disabled = type
      this.$refs.memberEdit.disabledEdit(type)
    },
    // 弹出审核框
    handlerOpration () {
      this.dialogVisible = true
    },
    handleClose () {
      this.dialogVisible = false
      this.dialogForm = {}
    },
    handleAudit () {
      this.$refs['dialogForm'].validate(async (valid) => {
        if (valid) {
          try {
            await this.$HTTP.ApiMember.audit({
              applyIds: [this.$route.query.applyId],
              auditStatus: this.dialogForm.auditStatus,
              roleType: 1
            })
            this.$message.success('操作成功')
            this.handleClose()
          } catch (error) {
            this.$message.error(error.message || '操作失败')
          }
        } else {
          return false
        }
      })
    },
    // 提交审核
    async audit () {
      this.$HTTP.ApiMember.audit({
        applyIds: [this.form.applyId],
        auditStatus: this.form.auditStatus,
        roleType: 1
      })
    }
  }
}
</script>
